function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useEffect, useState } from 'react';
import { Tabs } from 'udesk-ui';
var TabPane = Tabs.TabPane;
var PageHeaderFooter = function PageHeaderFooter(props) {
  var _navigationTabs$filte, _navigationTabs$filte2;
  var antdFooter = props.antdFooter,
    _props$navigationTabs = props.navigationTabs,
    navigationTabs = _props$navigationTabs === void 0 ? [] : _props$navigationTabs,
    onChange = props.onChange,
    currentNavigationPath = props.currentNavigationPath;
  var firstNavigationTab =
    (_navigationTabs$filte =
      (_navigationTabs$filte2 = navigationTabs.filter(function (t) {
        return !t.hidden;
      })) === null || _navigationTabs$filte2 === void 0
        ? void 0
        : _navigationTabs$filte2[0]) !== null && _navigationTabs$filte !== void 0
      ? _navigationTabs$filte
      : null;
  var _useState = useState(
      firstNavigationTab === null || firstNavigationTab === void 0
        ? void 0
        : firstNavigationTab.path,
    ),
    _useState2 = _slicedToArray(_useState, 2),
    activeKey = _useState2[0],
    setActiveKey = _useState2[1];
  useEffect(
    function () {
      if (!currentNavigationPath) return;
      var activeTabItem = navigationTabs
        .filter(function (t) {
          return !t.hidden;
        })
        .find(function (tab) {
          return currentNavigationPath.endsWith(tab.path);
        });
      // TODO 是否需要处理当前所在tab被hidden的情况？
      activeTabItem && setActiveKey(activeTabItem.path);
    },
    [currentNavigationPath],
  );
  var onTabsChange = function onTabsChange(activeKey) {
    setActiveKey(activeKey);
    var tab = navigationTabs.find(function (t) {
      return t.path === activeKey;
    });
    if (tab) {
      onChange === null || onChange === void 0 ? void 0 : onChange(tab);
      setActiveKey(tab.path);
    }
  };
  if (!antdFooter && !navigationTabs) return null;
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    antdFooter,
    /*#__PURE__*/ React.createElement(
      Tabs,
      {
        activeKey: activeKey,
        onChange: onTabsChange,
      },
      navigationTabs.map(function (tab, i) {
        if (tab.hidden) return null;
        return /*#__PURE__*/ React.createElement(TabPane, {
          tab: tab.text,
          key: tab.path,
        });
      }),
    ),
  );
};
export { PageHeaderFooter };
